let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("crCW8")).then(() => parcelRequire('2eaZq'));